import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Container, Row, Col, DealerCard, Map } from "@perxis-auto/ui-kit/lib";
import clsx from "clsx";
import styles from "./DealerMap.module.scss.js";
const DealerMap = memo(function DealerMap2({
  isHidden,
  location,
  contact,
  mapRef,
  bodyRef,
  ...props
}) {
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsxs("section", { className: styles.dealerMap, ref: mapRef, children: [
    /* @__PURE__ */ jsx(Container, { className: styles.dealerMap__cardContainer, children: /* @__PURE__ */ jsx(Row, { align: "middle", className: styles.dealerMap__row, children: /* @__PURE__ */ jsx(Col, { sm: 0, md: 12, lg: 14, xl: 12, xxl: 10, ref: bodyRef, className: styles.dealerMap__dealerCard, children: /* @__PURE__ */ jsx(DealerCard, { children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-green"], children: [
      /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(DealerCard.Location, { ...location }) }),
      /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(DealerCard.Contact, { ...contact }) })
    ] }) }) }) }) }),
    /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsx(Col, { span: 24, className: styles.dealerMap__mapWrapper, children: /* @__PURE__ */ jsx(Map, { fullscreenControl: false, ...props }) }),
      /* @__PURE__ */ jsx(Col, { xs: 24, sm: 24, md: 0, children: /* @__PURE__ */ jsx(DealerCard, { className: styles.dealerMap__dealerCardInfo, children: /* @__PURE__ */ jsxs(Container, { children: [
        /* @__PURE__ */ jsx(
          DealerCard.Location,
          {
            ...location,
            className: clsx(styles.dealerMap__dealerLocation, location.className)
          }
        ),
        /* @__PURE__ */ jsx(DealerCard.Contact, { ...contact, className: clsx(styles.dealerMap__dealerContact, contact.className) })
      ] }) }) })
    ] })
  ] });
});
export {
  DealerMap
};
